
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
//import DemosDrawer from "@/layout/extras/DemosDrawer.vue";
import EthocaDetailsDrawer from "@/layout/extras/EthocaDetailsDrawer.vue";
import EthocaAlertsTotal from "@/components/widgets/mixed/EthocaAlertsTotal.vue";

export default defineComponent({
  name: "ethoca",
  components: {
    Datatable,
    EthocaDetailsDrawer,
    EthocaAlertsTotal,
  },
  setup() {
    onMounted(async () => {
      setCurrentPageTitle("Ethoca Alerts");
      loading.value = true;
      setTimeout(async () => {
        tableData.value = await getEthocaAlerts(pagination.value, sort.value);
        loading.value = false;
      }, 1000);
    });
    const store = useStore();
    const searchParam = ref({
      search: "",
      alert_id: "",
      merchant_id: "",
      statusid2: "",
      cc_bin: "",
      cc_last: "",
      descriptor: "",
      amount: "",
    });
    const selectedAlert = ref({});
    const pagination = ref({
      page: 1,
      rowsPerPage: 5,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });
    const checkedAlerts = ref([]);
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
      },
      {
        name: "ID",
        key: "alert_id",
        sortable: true,
      },
      {
        name: "Merchant Id",
        key: "merchant_id",
        sortable: true,
      },
      {
        name: "Status",
        key: "statusid2",
        sortable: true,
      },
      {
        name: "Date",
        key: "alert_date",
        sortable: true,
      },
      {
        name: "Last",
        key: "cc_last",
      },
      {
        name: "Amount",
        key: "amount",
      },
      {
        name: "Descriptor",
        key: "descriptor",
      },
      {
        name: "Issuer",
        key: "issuer_name",
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);
    const tableData = ref({
      data: [],
      meta: {
        total: 0,
      },
    });
    const loading = ref(true);

    const openDrawer = (val) => {
      selectedAlert.value = val;
      DrawerComponent?.getInstance("ethoca_drawer")?.show();
    };
    const didClosedDrawer = async () => {
      loading.value = true;
      tableData.value = await getEthocaAlerts(pagination.value, sort.value);
      loading.value = false;
    };
    const search = async () => {
      loading.value = true;
      tableData.value = await getEthocaAlerts(pagination.value, sort.value);
      loading.value = false;
    };
    const getEthocaAlerts = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }

        let url = `alerts/ethoca?group_id=${store.getters.currentUser.data.companygroupid}offset=${offset}&limit=${rowsPerPage}${sortParam}`;

        if (searchParam.value.search !== "") {
          url = `${url}&search[]=${searchParam.value.search}`;
        }
        if (searchParam.value.alert_id !== "") {
          url = `${url}&alert_id=${searchParam.value.alert_id}`;
        }
        if (searchParam.value.merchant_id !== "") {
          url = `${url}&merchant_id=${searchParam.value.merchant_id}`;
        }
        if (searchParam.value.statusid2 !== "") {
          url = `${url}&statusid2=${searchParam.value.statusid2}`;
        }
        if (searchParam.value.cc_last !== "") {
          url = `${url}&cc_last=${searchParam.value.cc_last}`;
        }
        if (searchParam.value.descriptor !== "") {
          url = `${url}&descriptor=${searchParam.value.descriptor}`;
        }
        if (searchParam.value.amount !== "") {
          url = `${url}&amount=${searchParam.value.amount}`;
        }

        const { data } = await ApiService.get(url);
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };
    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      tableData.value = await getEthocaAlerts(pagination.value, sort.value);
      loading.value = false;
    };
    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      tableData.value = await getEthocaAlerts(pagination.value, sort.value);
      loading.value = false;
    };
    const onItemsPerPageChange = async (val) => {
      pagination.value.rowsPerPage = val;

      loading.value = true;
      tableData.value = await getEthocaAlerts(pagination.value, sort.value);
      loading.value = false;
    };
    const deleteCustomer = (alert_id) => {
      console.log(alert_id);
    };
    return {
      searchParam,
      tableData,
      tableHeader,
      loading,
      pagination,
      search,
      onCurrentChange,
      onSort,
      onItemsPerPageChange,
      deleteCustomer,
      selectedAlert,
      openDrawer,
      didClosedDrawer,
      checkedAlerts,
    };
  },
});
